const API_BASE = process.env.REACT_APP_API_BASE || 'https://phenoguessr.party/api';

export async function createGame() {
  const response = await fetch(`${API_BASE}/game/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Failed to create game: ${response.status}`);
  }

  return response.json();
}

export async function getGame(gameId) {
  const response = await fetch(`${API_BASE}/game/${gameId}`);

  if (!response.ok) {
    throw new Error(`Failed to get game: ${response.status}`);
  }

  return response.json();
}

export async function createDailyGame() {
  const response = await fetch(`${API_BASE}/cron/daily-game`);

  if (!response.ok) {
    throw new Error(`Failed to load daily game: ${response.status}`);
  }

  return response.json();
}

export async function getRandomPhenotype() {
  const response = await fetch(`${API_BASE}/random`);

  if (!response.ok) {
    throw new Error(`Failed to get random phenotype: ${response.status}`);
  }

  return response.json();
}
